import { createFileRoute } from "@tanstack/react-router"
import { useTranslation } from "react-i18next"
import { AuthContainer } from "../-components/auth-container"
import { CreateUserAuthenticationFactorForm } from "@/routes/-components/user-authentication-factor/create-user-authentication-factor-form"

export const Route = createFileRoute("/authenticate/mfa/create")({
  component: CreateUserAuthenticationFactor,
  validateSearch: (search: { returnUrl?: string }) => {
    return {
      returnUrl: search.returnUrl,
    }
  },
})

export function CreateUserAuthenticationFactor() {
  const navigate = Route.useNavigate()
  const { t } = useTranslation("app_server")
  const search = Route.useSearch()

  return (
    <AuthContainer
      title={t("UserAuthenticationFactor_CreateAuthenticationFactor")}
    >
      <CreateUserAuthenticationFactorForm
        onCancel={() =>
          navigate({
            to: "/authenticate/login",
            search: { returnUrl: search.returnUrl },
          })
        }
        onSuccess={(id) =>
          navigate({
            to: "/authenticate/mfa/$id/register",
            params: { id: id.toString() },
          })
        }
      />
    </AuthContainer>
  )
}
